module.exports = __webpack_public_path__ + "static/media/mala-hover.292fbfe4.svg";